import { Svg } from './svg'

export const NotetakerIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.473 7.96614C3.65403 7.47692 4.34597 7.47692 4.527 7.96614L5.27626 9.99098C5.33317 10.1448 5.45444
      10.2661 5.60825 10.323L7.63309 11.0722C8.1223 11.2533 8.1223 11.9452 7.63309 12.1262L5.60825 12.8755C5.45444
      12.9324 5.33317 13.0537 5.27626 13.2075L4.527 15.2323C4.34597 15.7215 3.65403 15.7215 3.473 15.2323L2.72374
      13.2075C2.66683 13.0537 2.54556 12.9324 2.39175 12.8755L0.366913 12.1262C-0.122304 11.9452 -0.122304 11.2533
      0.366913 11.0722L2.39175 10.323C2.54556 10.2661 2.66683 10.1448 2.72374 9.99098L3.473 7.96614Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.08203 3.00415V7.36443C2.08203 7.91672 1.63432 8.36443 1.08203 8.36443C0.529746 8.36443 0.0820313 7.91672
      0.0820313 7.36443V3.00415C0.0820313 1.89958 0.97746 1.00415 2.08203 1.00415H10.1812C11.2858 1.00415 12.1812 1.89958
      12.1812 3.00415V3.61526L13.6826 2.9611C14.6734 2.52939 15.7817 3.25547 15.7817 4.33623V10.9611C15.7817 12.0354 14.6855
      12.7614 13.6964 12.3422L12.1812 11.7001V12.2419C12.1812 13.3465 11.2858 14.2419 10.1812 14.2419H9.53204C8.97976 14.2419
       8.53204 13.7942 8.53204 13.2419C8.53204 12.6897 8.97976 12.2419 9.53204 12.2419H10.1812V8.68028L13.7817
       10.2062V5.09949L10.1812 6.66831L10.1812 3.00415L2.08203 3.00415Z"
      fill="currentColor"
    />
  </Svg>
)
